/**
 * Internal-only. The single place this module speaks to Google.
 *
 * Analogue of `dataLayer.js` in the analytics foundation: one writer, so the
 * wire format cannot drift per call site. Nothing outside `lib/consent-mode`
 * should call this — go through `consentMode.js`.
 *
 * WHY THIS IS NOT `pushToDataLayer` FROM `lib/analytics`
 * -----------------------------------------------------
 * They look interchangeable and are not. `pushToDataLayer` pushes a plain
 * OBJECT, which is the correct shape for an analytics event. A gtag command is
 * an ARGUMENTS OBJECT — an array-like whose numeric keys carry
 * `("consent", "update", {...})`. GTM inspects pushed values and only treats
 * arguments objects as gtag commands; push `["consent", "update", {...}]` as a
 * real array and it is silently ignored, leaving consent permanently at the
 * default with no error anywhere. Hence the un-idiomatic `arguments` below, and
 * hence a separate writer rather than reaching into the analytics foundation
 * (which Phase 7.0B leaves untouched by design).
 */

/**
 * Push a gtag command onto the dataLayer.
 *
 * Declared as a classic function, and pushing `arguments` verbatim, on purpose —
 * see the note above. A rest parameter would produce a real array and break
 * Consent Mode.
 *
 * `window.dataLayer` is normally already initialized: the inline snippet in
 * index.html creates it before GTM loads. The `|| []` is defensive, for the case
 * where that snippet never ran (an ad blocker stripped it, or a surface is
 * mis-configured) — commands then queue harmlessly for a GTM that may never
 * arrive, which is inert rather than a crash.
 *
 * @returns {void}
 */
export function gtag() {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}
